/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './css/PopularDirections.css';
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import {
  POPULAR_TITLE,
  TURKEY,
  UAE,
  EGYPT,
  THAILAND,
  PRICE_FROM,
  PER_PERSON,
  TURKEY_DESC1,
  TURKEY_DESC2,
  UAE_DESC1,
  UAE_DESC2,
  EGYPT_DESC1,
  EGYPT_DESC2,
  THAILAND_DESC1,
  THAILAND_DESC2,
} from '../../../Utils/Constants/HomePageConstants';
import { formatPrice, getNightsTextNoRange } from '../../../Utils/CommonUtils';
import { ReactComponent as ArrouRound } from '../../../images/white-arrow-round-r.svg';
import { ReactComponent as BynIco } from '../../../images/byn-symbol-r.svg';
import { ReactComponent as GrayArrow } from '../../../images/gray-arrow-r.svg';

// prices in BYN, converted from NBRB rate on 2026-10-20
const directions = [
  {
    link: '/turkey/',
    className: 'dir_swipe_turkey',
    title: TURKEY,
    nights: 7,
    price: 1933,
    desc1: TURKEY_DESC1,
    desc2: TURKEY_DESC2,
  },
  {
    link: '/uae/',
    className: 'dir_swipe_uae',
    title: UAE,
    nights: 8,
    price: 2184,
    desc1: UAE_DESC1,
    desc2: UAE_DESC2,
  },
  {
    link: '/egypt/',
    className: 'dir_swipe_egypt',
    title: EGYPT,
    nights: 10,
    price: 2518,
    desc1: EGYPT_DESC1,
    desc2: EGYPT_DESC2,
  },
  {
    link: '/thailand/',
    className: 'dir_swipe_thailand',
    title: THAILAND,
    nights: 10,
    price: 3445,
    desc1: THAILAND_DESC1,
    desc2: THAILAND_DESC2,
  },
];

function PopularDirections() {
  const swipeRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [lastIndex, setLastIndex] = useState();

  const renderPrice = (price) => (
    <div className="dir_item_price">
      {`${PRICE_FROM} ${formatPrice(price)}`}
      <BynIco className="dir_item_currency_ico" />
      {PER_PERSON}
    </div>
  );

  const renderSlide = (item) => (
    <SwiperSlide key={item.link}>
      <Link to={item.link}>
        <div className={`dir_swipe_item ${item.className}`}>
          <div className="dir_item_title_w">
            <div className="dir_item_title">{item.title}</div>
            <div className="dir_item_nights mb_25">
              {getNightsTextNoRange(item.nights)}
            </div>
          </div>
          {renderPrice(item.price)}
          <div className="dir_blur_w">
            <div className="dir_blur_content">
              <ArrouRound className="dir_item_arrow" />
              <div className="dir_item_text mb_20">{item.desc1}</div>
              <div className="dir_item_text">{item.desc2}</div>
            </div>
          </div>
        </div>
      </Link>
    </SwiperSlide>
  );

  const slideLeft = () => {
    if (swipeRef.current) {
      swipeRef.current.slideNext();
    }
  };

  const slideRight = () => {
    if (swipeRef.current) {
      swipeRef.current.slidePrev();
    }
  };

  const getLeftButton = () => {
    if (activeIndex === 0) {
      return <GrayArrow className="dir_swipe_gray_arrow_left" />;
    } else {
      return (
        <button
          type="button"
          className="dir_swipe_button dir_swipe_left"
          onClick={() => slideRight()}
        />
      );
    }
  };

  const getRightButton = () => {
    if (activeIndex === lastIndex) {
      return <GrayArrow className="dir_swipe_gray_arrow_right" />;
    } else {
      return (
        <button
          type="button"
          className="dir_swipe_button"
          onClick={() => slideLeft()}
        />
      );
    }
  };

  const onSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  return (
    <div className="direct_w">
      <div className="containerW">
        <div className="dir_section_title">{POPULAR_TITLE}</div>
        <div className="dir_swipe_w">
          <Swiper
            modules={[Pagination, Scrollbar, A11y]}
            spaceBetween={20}
            slidesPerView={3}
            pagination={{ clickable: true, type: 'bullets' }}
            scrollbar={{ draggable: true }}
            onSlideChange={(swiper) => onSlideChange(swiper)}
            onSwiper={(swiper) => {
              setLastIndex(swiper.slides.length - 3);
              swipeRef.current = swiper;
            }}
          >
            {directions.map((item) => renderSlide(item))}
          </Swiper>
          <div className="dir_swiper_buttows">
            {getLeftButton()}
            {getRightButton()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PopularDirections;
